import React, { useState } from "react"
import { useIntl } from "react-intl"
import { Button, Popover } from "@walmart-web/livingdesign-components"
import IconInformation from "assets/icons/iconInformation.svg"
import "./index.scss"

interface InformationPopoverProperties {
	title?: string
	text?: string
	width?: string
}

const InformationPopover: React.FC<InformationPopoverProperties> = ({
	title,
	text,
	width = "12.5rem",
}): JSX.Element => {
	const ref = React.useRef<HTMLButtonElement>(null)
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const intl = useIntl()

	return (
		<Popover
			position="top"
			content={
				<div style={{ width, height: "auto" }}>
					{title && (
						<div className="information-title">
							{intl.formatMessage({ id: title })}
						</div>
					)}
					{text && (
						<div className="information-text">
							{intl.formatMessage({ id: text })}
						</div>
					)}
				</div>
			}
			isOpen={isOpen}
			hasNubbin
			onClose={() => setIsOpen(false)}
			triggerRef={ref}
			data-testid="information-popover"
		>
			<Button
				ref={ref}
				UNSAFE_className="tooltip-button"
				onClick={() => setIsOpen(!isOpen)}
				variant="tertiary"
				role="filter-button"
			>
				<img
					className="info-button"
					src={IconInformation}
					alt="icon-information"
				/>
			</Button>
		</Popover>
	)
}

export default InformationPopover
